(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["elfine-viewer-counter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elfine-viewer-counter')) {
    customElements.define('elfine-viewer-counter', class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.timer);
        if (this.onVisibilityChange) document.removeEventListener('visibilitychange', this.onVisibilityChange);
        const update = (force = false) => {
          if (document.hidden) return;
          const key = 'elfine-viewers-' + this.dataset.product;
          let state = this.viewerState;
          try { state = JSON.parse(sessionStorage.getItem(key)) || state; } catch {}
          if (force || !state || !Number.isInteger(state.count) || state.count < 5 || state.count > 68 || !Number.isFinite(state.time) || Date.now() - state.time >= 8000) {
            let count = 5 + Math.floor(Math.random() * 64);
            if (count === (this.viewerState?.count ?? state?.count)) count = count === 68 ? 5 : count + 1;
            state = { count, time: Date.now() };
            try { sessionStorage.setItem(key, JSON.stringify(state)); } catch {}
          }
          this.viewerState = state;
          const output = this.querySelector('[data-viewer-count]');
          if (output) output.textContent = state.count;
        };
        update();
        this.timer = setInterval(() => update(true), 8000);
        this.onVisibilityChange = () => update();
        document.addEventListener('visibilitychange', this.onVisibilityChange);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["elfine-whatsapp-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elfine-whatsapp-order')) {
    customElements.define('elfine-whatsapp-order', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const link = this.querySelector('a');
        if (!link) return;
        const update = () => {
          const details = this.closest('.product-details');
          const form = details?.querySelector('product-form-component form');
          const variantId = form?.querySelector('[name="id"]')?.value;
          const quantity = Math.max(1, Number.parseInt(form?.querySelector('[name="quantity"]')?.value || '1', 10) || 1);
          let variants = [];
          try { variants = JSON.parse(this.querySelector('[data-order-variants]')?.textContent || '[]'); } catch {}
          const variant = variants.find(item => String(item.id) === String(variantId));
          const url = new URL(this.dataset.url);
          if (variantId) url.searchParams.set('variant', variantId);
          const lines = [this.dataset.greeting, this.dataset.title];
          if (variant && variant.title !== 'Default Title') lines.push(this.dataset.optionLabel + ': ' + variant.title);
          lines.push(this.dataset.quantityLabel + ': ' + quantity, url.href);
          link.href = 'https://wa.me/' + this.dataset.phone.replace(/\D/g, '') + '?text=' + encodeURIComponent(lines.join('\n'));
        };
        for (const eventName of ['click', 'pointerdown', 'focus', 'contextmenu']) {
          link.addEventListener(eventName, update, { signal: this.controller.signal });
        }
        update();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
